import axios, { apiWrapper } from '../../../base/APIClient';
import { FOOTER } from '../../../base/Url';

export const getFooterDetails = (hotelCode, useLoader = false) => {
  const { GET_FOOTER_DETAILS } = FOOTER;
  const url = GET_FOOTER_DETAILS(hotelCode);
  return apiWrapper(axios.get(url, { useLoader }));
};
